import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import isNil from "lodash/isNil";
import getNodesMaps from "../nodeOrEdgeSourceDataHandling/getNodesMaps";
import nodeSourceFactory from "../nodeOrEdgeSourceDataHandling/nodeSourceFactory";
import addOrUpdateNodeLabel from "../nodeRendering/addOrUpdateNodeLabel";
import createNode from "./createNode";
export default (graphComponentRef, documentObjects, nodeSource, layout, updateLabel = true) => {
    var _a, _b;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return { isNew: false, node: undefined, tag: undefined };
    const { groupedNodesMap, regularNodesMap } = getNodesMaps(graphComponentRef);
    if (groupedNodesMap[nodeSource.NodeId])
        return { isNew: false, node: undefined, tag: undefined };
    let node = regularNodesMap[nodeSource.NodeId];
    if (!node && !nodeSource.DocumentObjectId)
        return { isNew: false, node: undefined };
    const isNew = !node;
    const documentObjectId = nodeSource.DocumentObjectId ||
        ((node === null || node === void 0 ? void 0 : node.tag) && ((_b = node === null || node === void 0 ? void 0 : node.tag) === null || _b === void 0 ? void 0 : _b.DocumentObjectId));
    const documentObject = documentObjects && documentObjectId ? documentObjects[documentObjectId] : undefined;
    if (!node) {
        if (nodeSource.DocumentObjectId)
            node = createNode(graphComponentRef, documentObject, nodeSource, layout);
    }
    else if (Boolean(nodeSource.DocumentObjectId) || !node.tag) {
        node.tag = nodeSourceFactory({ ...nodeSource, DocumentObject: documentObject });
    }
    else {
        const resultTag = node.tag;
        if (nodeSource.AttributeValues) {
            resultTag.AttributeValues = cloneDeep(resultTag.AttributeValues || []);
            forEach(nodeSource.AttributeValues, attr => {
                const prevIndex = findIndex(resultTag.AttributeValues, ["Key", attr.Key]);
                if (prevIndex === -1)
                    !isNil(attr.Value) &&
                        resultTag.AttributeValues.push({
                            Key: attr.Key,
                            Value: attr.Value
                        });
                else if (isNil(attr.Value))
                    resultTag.AttributeValues.splice(prevIndex, 1);
                else
                    resultTag.AttributeValues[prevIndex].Value = attr.Value;
            });
            node.tag = nodeSourceFactory(resultTag, documentObjects);
        }
        else {
            node.tag = { ...resultTag, ...nodeSource };
        }
    }
    node &&
        (updateLabel || !isNew) &&
        addOrUpdateNodeLabel(graphComponentRef, node, documentObjects ? documentObject : undefined);
    return { isNew, node, tag: node === null || node === void 0 ? void 0 : node.tag };
};
